import { dispatch } from '@omni/kit/ActionHandler';
import { ENV } from '@omni/kit/Environment';
import { getStoredItem } from '@omni/kit/storage';
import { getActiveAppKey } from '@omni/kit/utilities/NativeHelpers';
import { Platform } from 'react-native';

class EnvironmentService {
  private static instance: EnvironmentService;
  private initPromise: Promise<boolean> | null = null;

  public static getInstance(): EnvironmentService {
    if (!EnvironmentService.instance) {
      EnvironmentService.instance = new EnvironmentService();
    }

    return EnvironmentService.instance;
  }

  public async initialize(): Promise<boolean> {
    // If there's already an initialization in progress, wait for it
    if (this.initPromise) {
      return this.initPromise;
    }

    this.initPromise = (async () => {
      let environmentReady = false;

      try {
        const prevEnv = await getStoredItem('environment');
        const currentEnv = ENV;

        // clear the cache if the environment changed
        // e.g. QA engineer switching bewteen dev, stage and prod builds in test builds from TestFlight/Firebase
        // e.g. Developer switching between dev, stage and prod environments in the env.config.ts
        if (Platform.OS !== 'web' && prevEnv && prevEnv !== currentEnv) {
          environmentReady = false;

          // the appKey from the ApplicationContextProvider is not always the active appkey
          // so we need to get the active appkey from the native bridge
          const activeAppKey = await getActiveAppKey();

          dispatch({
            handler: 'app',
            appkey: activeAppKey,
            command: 'reload',
          });
        } else {
          environmentReady = true; // Environment is ready
        }
      } catch {
      } finally {
        // Clear the promise so future initialization requests can proceed
        this.initPromise = null;
      }

      return environmentReady;
    })();

    return this.initPromise;
  }
}

export default EnvironmentService;
